import { FileText, Mail, User, CheckCircle } from 'lucide-react'
import Header from '../components/layout/Header'

const Requisites = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary-100 mb-4">
            <FileText className="w-8 h-8 text-primary-600" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900">Реквизиты ИП / Самозанятого</h1>
          <p className="mt-2 text-gray-600">Платёжные и контактные данные исполнителя</p>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
          {/* ФИО */}
          <div className="p-6 border-b border-gray-100">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary-50 flex items-center justify-center">
                <User className="w-5 h-5 text-primary-600" />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-gray-900">Курбанов Камран Айтакинович</h2>
                <div className="mt-1 inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200">
                  <CheckCircle className="w-3.5 h-3.5" />
                  Самозанятый (плательщик НПД)
                </div>
              </div>
            </div>
          </div>

          {/* ИНН */}
          <div className="p-6 border-b border-gray-100">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gray-50 flex items-center justify-center">
                <span className="text-sm font-bold text-gray-500">ИНН</span>
              </div>
              <div>
                <h2 className="text-lg font-semibold text-gray-900">ИНН</h2>
                <p className="mt-1 text-2xl font-mono font-bold text-gray-900 tracking-wider">180805638897</p>
              </div>
            </div>
          </div>

          {/* Контакты */}
          <div className="p-6 border-b border-gray-100">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center">
                <Mail className="w-5 h-5 text-blue-600" />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-gray-900">Контакты для связи</h2>
                <p className="mt-1 text-gray-600">
                  Email:{' '}
                  <a href="mailto:kamran@kurbanov.me" className="text-primary-600 hover:text-primary-700 font-medium">
                    kamran@kurbanov.me
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* Примечание */}
          <div className="p-6 bg-amber-50">
            <div className="flex items-start gap-4">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
                <span className="text-lg font-bold text-amber-600">!</span>
              </div>
              <div>
                <h2 className="text-lg font-semibold text-amber-900">Примечание</h2>
                <p className="mt-1 text-amber-800 text-sm leading-relaxed">
                  Данный сервис предоставляется самозанятым гражданином
                  в соответствии с Федеральным законом от 27.11.2018 № 422-ФЗ
                  "О проведении эксперимента по установлению специального
                  налогового режима «Налог на профессиональный доход»".
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default Requisites